import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
} from "redux-persist";

import automerge from "redux-persist/es/stateReconciler/autoMergeLevel1";
import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import { rootReducer } from "./rootReducer";
import storage from "redux-persist/lib/storage";

export const KEY = "293939fk";

const persistConfig = {
  key: KEY,
  storage, // Modern JS shorthand for storage: storage
  stateReconciler: automerge,
  // CRITICAL FIX: We blacklist "user" so stale tokens are not loaded from local storage.
  // OIDC handles the auth session securely on its own.
  blacklist: ["user", "error"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) => {
    // 1. Get the default RTK middlewares and configure them for redux-persist
    const middlewares = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });

    // 2. Conditionally add the logger ONLY during development
    // This prevents state leakage and performance hits in production
    if (process.env.NODE_ENV !== "production") {
      const logger = createLogger({ duration: true });
      middlewares.push(logger);
    }

    return middlewares;
  },
});
